export type SalaryData = {
  status: string
  message: string
  data: {
    minimum_salary: number
    average_salary: number
    maximum_salary: number
    education_level_salary: Record<EducationLevelEntry, number>
    experience_level_salary: Record<ExperienceLevelEntry, number>
    top_states_salary: [string, number][]
    top_cities_salary: [string, number][]
    title: string
  }
}

export type EducationLevelEntry = 'Bachelor' | 'Master'

export const ExperienceLevels = ['10+', '6to9', '3to6', '1to3', 'Fresher'] as const
export type ExperienceLevelEntry = (typeof ExperienceLevels)[number]

export const ExperienceLevelLabels = {
  '10+': '10+ Years',
  '6to9': '6-9 Years',
  '3to6': '3-6 Years',
  '1to3': '1-3 Years',
  Fresher: 'Fresher',
} as { [key in ExperienceLevelEntry]: string }
